export const mainType = {
    value: 'main',
    label: 'campus-main',
}export const mainType = {
    value: 'main',
    label: 'campus-main',
}